export enum CampaignCode
{
    "쇼핑 정답 맞추기"="nshop_quiz",
    "플레이스 명소 맞추기"="nplace_quiz",
    "플레이스 명소 저장하기"="nplace_save",
}

// key들의 타입 추출 (리터럴 유니온 타입)
export type CampaignCodeKeys = keyof typeof CampaignCode

// value들의 타입 추출 (리터럴 유니온 타입)
export type CampaignCodeValues = `${CampaignCode}`